/* @ngInject */
function DeleteSectionDialogController ($scope, ArtCollectionsService, ToastService) {
  $scope.archivingConfirmed = false

  $scope.closeModal = (section) => {
    $scope.returnData = { section }
    $scope.close($scope.returnData)
  }

  $scope.deleteArtSection = (section) => {
    ArtCollectionsService.archiveArtCollection(section.id)
      .catch(ToastService.defaultErrorToast)
      .then(() => {
        $scope.closeModal(section)
      })
  }

  $scope.onChangeArchiveCheckbox = (event) => {
    const { value } = event.detail
    $scope.archivingConfirmed = value
  }
}

export { DeleteSectionDialogController }
